import { If } from 'cdui-js';
import i18n from '../../../../i18n';
import { isH5User } from '../../../../stores/user';
import { exitH5OpenAccountFlow } from '../../utils/exitH5OpenAccountFlow';

const BAR_HEIGHT = '54px';

/**
 * H5 开户 / 加开户专用：右上角「退出」。
 * App 不展示（原生顶栏负责返回）。
 */
export const H5OpenFlowExitBar = () => (
  <If when={isH5User()}>
    <div class="h5-open-flow-exit-bar-wrap">
      <div
        class="h5-open-flow-exit-bar fixed flex align-center justify-end padding-m-x bg-c "
        style={{
          top: 0,
          left: 0,
          right: 0,
          height: BAR_HEIGHT,
          'padding-top': 'env(safe-area-inset-top, 0px)',
          'box-sizing': 'content-box',
          'z-index': 100,
          cursor: 'pointer',
        }}
      >
        <span
          class="color-D font-s-S"
          role="button"
          tabIndex={0}
          onclick={() => exitH5OpenAccountFlow()}
        >
          {i18n.OpenProgress.Common.Exit}
        </span>
      </div>
      <div
        class="h5-open-flow-exit-bar-placeholder"
        style={{ height: `calc(${BAR_HEIGHT} + env(safe-area-inset-top, 0px))`, 'flex-shrink': 0 }}
      />
    </div>
  </If>
);
